import type { StatusKind } from '../components/StatusBadge';
import type { HealthState } from '../types/shared';

/**
 * Format ISO date string to relative time (Asia/Seoul aware)
 */
export function formatGatewayDate(iso: string): string {
  const now = Date.now();
  const date = new Date(iso);
  const diffMs = now - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) return `${diffSec}초 전`;
  if (diffMin < 60) return `${diffMin}분 전`;
  if (diffHour < 24) return `${diffHour}시간 전`;
  if (diffDay < 7) return `${diffDay}일 전`;

  return date.toLocaleDateString('ko-KR', { timeZone: 'Asia/Seoul' });
}

/**
 * Return a CSS variable string based on status kind
 */
export function colorByStatus(status: StatusKind): string {
  switch (status) {
    case 'active':
    case 'healthy':
    case 'enabled':
      return 'var(--color-healthy)';
    case 'deprecated':
    case 'pending':
      return 'var(--color-warning)';
    case 'unhealthy':
      return 'var(--color-unhealthy)';
    case 'disabled':
    case 'unknown':
      return 'var(--color-muted)';
    default:
      return 'var(--color-text-secondary)';
  }
}

/**
 * BE GatewayTargetResponse.healthStatus (HEALTHY | UNHEALTHY | UNKNOWN | DRAINING, 원본 대문자)를
 * FE HealthIndicator 가 사용하는 소문자 HealthState 로 정규화한다 (#621).
 */
export function normalizeHealthState(status: string | null | undefined): HealthState {
  switch ((status ?? '').toUpperCase()) {
    case 'HEALTHY':
      return 'healthy';
    case 'UNHEALTHY':
      return 'unhealthy';
    case 'DRAINING':
      return 'draining';
    default:
      return 'unknown';
  }
}
